import { render, staticRenderFns } from "./earned-points.vue?vue&type=template&id=7bf006f1&"
import script from "./earned-points.vue?vue&type=script&lang=js&"
export * from "./earned-points.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports